"use client";

import { cn } from "@scott/ui/utils/cn";
import type { PaymentIconKey } from "../../../types";
import { Amex, Klarna, Mastercard, Paypal, Visa } from "../icon";

export interface paymentProps {
  imgSrcs: string[];
  className?: string;
}

const PaymentIcons: Record<PaymentIconKey, React.ComponentType> = {
  v: Visa,
  m: Mastercard,
  p: Paypal,
  k: Klarna,
  a: Amex,
  b: () => <p>Billpay</p>,
  s: () => <p>Sofort</p>,
};

const FooterPayment = ({ className, imgSrcs }: paymentProps) => (
  <div
    className={cn(
      "container flex flex-row items-center justify-center gap-4 bg-transparent p-6 lg:py-6",
      className
    )}
  >
    <div className="hidden h-[50%] flex-1 border-neutral-lighter border-b-[1px] sm:block md:block lg:block xl:block" />
    {imgSrcs?.map((s, _index) => {
      const Icon = PaymentIcons[s as PaymentIconKey];
      return Icon ? <Icon key={`payment-icon-${s}`} /> : null;
    })}
    <div className="hidden h-[50%] flex-1 border-neutral-lighter border-b-[1px] sm:block md:block lg:block xl:block" />
  </div>
);

FooterPayment.displayName = "FooterPayment";

export { FooterPayment };
